export const VEHICLE_ENUMS_TAB = {
  CATEGORIES: "categories",
  COLORS: "colors",
  FUEL_TYPES: "fuel-types",
};
